(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gatz-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'gatz:plp-density';
  function init(root) {
    if (!root || root.dataset.gcReady === '1') return;
    root.dataset.gcReady = '1';
    var buttons = root.querySelectorAll('[data-gc-density]');
    function paint(value) {
      root.setAttribute('data-density', value);
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-gc-density') === value ? 'true' : 'false');
      }
    }
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    paint(saved === '1' || saved === '2' ? saved : (root.getAttribute('data-density') || '2'));
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].addEventListener('click', function () {
        var v = this.getAttribute('data-gc-density');
        paint(v);
        try { localStorage.setItem(KEY, v); } catch (e) {}
      });
    }
    var sort = root.querySelector('[data-gc-sort]');
    if (sort) sort.addEventListener('change', function () { if (this.form) this.form.submit(); });
    var fbtn = root.querySelector('[data-gc-filter]');
    var panel = root.querySelector('#gc-filterpanel');
    if (fbtn && panel) {
      if (panel.querySelector('.gc-chip.is-on')) { panel.hidden = false; fbtn.setAttribute('aria-expanded', 'true'); }
      fbtn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        fbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Only nudge the category bar when the current item is actually out of view.
    // The previous version ran whenever the row overflowed at all, so the bar
    // visibly lurched sideways on every load — that was the wobble.
    var strip = root.querySelector('[data-gc-catbar] .gc-catbar__list');
    var here = strip && strip.querySelector('.is-current');
    if (strip && here && strip.scrollWidth > strip.clientWidth + 2) {
      var s = strip.getBoundingClientRect();
      var h = here.getBoundingClientRect();
      if (h.left < s.left + 2 || h.right > s.right - 2) {
        strip.scrollLeft += (h.left - s.left) - 20;
      }
    }
  }
  function boot() {
    var roots = document.querySelectorAll('[data-gc-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-boheme"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
